<app-search-page-title [title]="title()"/>
